export default __webpack_public_path__ + "img/check.f425622d363be6ae8a2872bdac644ede.png";